/* ==========================================================================
   assets/no-buy-column.js
   The PVS-14 and PVS-31 buy column. NEW FILE. Nothing existing is edited.
   Built 2026-09-28 by lane PVS-BUY-LIVE-1 from the round 5 mockup Bon approved.

   WHAT THIS FILE IS ALLOWED TO KNOW
   Nothing. Every variant id, SKU, price, compare at price and availability
   arrives in the JSON that snippets/no-buy-column.liquid printed from Shopify at
   render time, so a price change or a sell out needs no edit here, and a market
   with its own currency is already priced in it.

   WHAT THIS FILE NEVER DOES
   It never writes an arrival sentence of its own. The card inside the arrival box
   is snippets/no-delivery-estimate.liquid (V8) and every word in it is the
   delivery estimate function's. This file reads the SAME answer only to work out
   Bon's "[Can Deliver In X Days]" line from the very two dates that card shows,
   and to say which of two parcels comes from where.

   TWO PARCELS MEAN TWO ANSWERS (added 2026-09-28, lane INTL-PVS-ESTIMATE).
   A kit SKU is deliberately refused a shipping window by the server, because
   its thermal half comes from a different supply chain. So on a two parcel kit
   this file asks the SAME function a second time about the plain PVS variant at
   the same housing and grade, which is the same unit the kit carries, and paints
   one row per parcel. Still not one word of its own: the goggle row is the
   server's sentence for the goggle, the thermal row is the approved copy for the
   thermal.

   THE CART IS THE LIVE PREDATOR PAGE'S CART, COPIED
   Read off assets/predator-kit.js and assets/pvs14-upsell.js. One POST to
   /cart/add.js, items in the live order (PREDATOR CORE, the dual dovetail
   bridge, then the PVS-14), no line item properties, no selling plan, no
   discount code, plus the drawer's own `sections` so it repaints. If the drawer
   cannot be driven the shopper lands on the cart page.

   No em dashes or en dashes anywhere in this file.
   ========================================================================== */
(function () {
  'use strict';

  var MONTHS = {
    jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
  };

  function boot(root) {
    if (root.getAttribute('data-no-buy-bound') === '1') return;
    root.setAttribute('data-no-buy-bound', '1');

    var holder = root.querySelector('script[data-no-buy-data]');
    var D;
    try { D = JSON.parse(holder.textContent); } catch (e) { return; }
    if (!D || !D.variants || !D.variants.length || !D.grades || !D.grades.length) return;

    var form = root.querySelector('[data-no-buy-form]');
    var vidEl = root.querySelector('[data-no-buy-vid]');
    var addBtn = root.querySelector('[data-no-buy-add]');
    var addLabel = root.querySelector('[data-no-buy-addlabel]');
    var addPrice = root.querySelector('[data-no-buy-addprice]');
    var errEl = root.querySelector('[data-no-buy-err]');
    var priceEl = root.querySelector('[data-no-buy-price]');
    var subEl = root.querySelector('[data-no-buy-subtotal]');
    var wasEl = root.querySelector('[data-no-buy-was]');
    var tagsEl = root.querySelector('[data-no-buy-tags]');
    var slider = root.querySelector('[data-no-buy-slider]');
    var range = root.querySelector('[data-no-buy-range]');
    var knob = root.querySelector('[data-no-buy-knob]');
    var fill = root.querySelector('[data-no-buy-fill]');
    var hintEl = root.querySelector('[data-no-buy-hint]');
    var barsEl = root.querySelector('[data-no-buy-bars]');
    var gfootEl = root.querySelector('[data-no-buy-gfoot]');
    var sampleEl = root.querySelector('[data-no-buy-sample]');
    var sampleWrap = root.querySelector('[data-no-buy-samplewrap]');
    var estHead = root.querySelector('[data-no-buy-esthead]');
    var daysEl = root.querySelector('[data-no-buy-days]');
    var rowsEl = root.querySelector('[data-no-buy-rows]');
    var cartEl = root.querySelector('[data-no-buy-cart]');
    var zoom = root.querySelector('[data-no-buy-zoom]');

    /* ------------------------------------------------------------- money.
       HOW MONEY IS WRITTEN IN THIS MARKET, learned from one known amount that
       Liquid formatted, never assumed. So a Canadian sees Canadian money and a
       shop that writes 1.234,56 gets 1.234,56. */
    var M = learnMoney(D.moneyProbe);

    function learnMoney(probe) {
      var s = String(probe == null ? '' : probe);
      var m = s.match(/[0-9][0-9.,   '`]*[0-9]|[0-9]/);
      if (!m) return null;
      var core = m[0];
      var out = {
        pre: s.slice(0, m.index),
        suf: s.slice(m.index + core.length),
        dec: 0,
        decSep: '.',
        grpSep: ''
      };
      var tail = core.match(/([.,])(\d{2})$/);
      var rest = core;
      if (tail) { out.dec = 2; out.decSep = tail[1]; rest = core.slice(0, core.length - 3); }
      var g = rest.match(/[.,   '`]/);
      if (g) out.grpSep = g[0];
      return out;
    }

    function money(cents) {
      var n = Number(cents);
      if (!isFinite(n)) return '';
      if (!M) return String(Math.round(n / 100));
      var neg = n < 0;
      n = Math.abs(n);
      var whole, frac = null;
      if (M.dec === 2) { whole = Math.floor(Math.round(n) / 100); frac = Math.round(n) % 100; }
      else { whole = Math.round(n / 100); }
      var w = String(whole);
      if (M.grpSep) w = w.replace(/\B(?=(\d{3})+(?!\d))/g, M.grpSep);
      var s = M.pre + w + (frac === null ? '' : M.decSep + (frac < 10 ? '0' : '') + frac) + M.suf;
      return (neg ? '-' : '') + s;
    }

    /* a price step for a grade stop: +$250 or -$100, whole amounts without cents */
    function moneyStep(cents) {
      var n = Math.round(Number(cents));
      if (!isFinite(n) || n === 0) return '';
      var s = money(Math.abs(n));
      if (M && M.dec === 2 && Math.abs(n) % 100 === 0) s = s.replace(M.decSep + '00', '');
      return (n > 0 ? '+' : '-') + s;
    }

    /* --------------------------------------------------------- the variants */
    var iH = D.iHouse, iF = D.iFom, iK = D.iKit;
    var kvBase = D.kvBase || '';
    var kvHeat = D.kvHeat || '';
    var hasKits = iK >= 0;
    var predOn = D.predOn === true && D.core && D.core.id > 0 && D.bridge && D.bridge.id > 0;

    function kitValueOf(kitId) {
      if (!hasKits) return null;
      return kitId === 'heat' ? kvHeat : kvBase;
    }

    /* The variant a choice really points at. The ADD PREDATOR kit is NOT a
       Shopify variant: it is the plain PVS-14 kit variant plus two more cart
       lines, exactly the way the live PREDATOR page sells it. */
    function variantFor(h, fomValue, kitId) {
      var kv = kitValueOf(kitId);
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (iH >= 0 && v.options[iH] !== h) continue;
        if (v.options[iF] !== fomValue) continue;
        if (hasKits && v.options[iK] !== kv) continue;
        return v;
      }
      return null;
    }

    /* Does this housing sell this grade at all, in any kit. A grade the housing
       has no variant for reads "Pro only" rather than "Sold out", because those
       are two different sentences to a shopper. */
    function fomExists(h, fomValue) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (iH >= 0 && v.options[iH] !== h) continue;
        if (v.options[iF] === fomValue) return true;
      }
      return false;
    }
    function fomBuyable(h, fomValue) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (iH >= 0 && v.options[iH] !== h) continue;
        if (v.options[iF] === fomValue && v.available) return true;
      }
      return false;
    }
    function kitBuyable(h, fomValue, kitId) {
      if (kitId === 'pred' && !predOn) return false;
      var v = variantFor(h, fomValue, kitId === 'pred' ? 'base' : kitId);
      if (!v || !v.available) return false;
      if (kitId === 'pred') return D.core.available === true;
      return true;
    }

    function kitPrice(h, fomValue, kitId) {
      var v = variantFor(h, fomValue, kitId === 'pred' ? 'base' : kitId);
      if (!v) return null;
      if (kitId === 'pred') return v.price + Number(D.core.price || 0);
      return v.price;
    }
    function kitCompare(h, fomValue, kitId) {
      var v = variantFor(h, fomValue, kitId === 'pred' ? 'base' : kitId);
      if (!v || !v.compare) return 0;
      if (kitId === 'pred') return v.compare + Number(D.core.compare || 0);
      return v.compare;
    }

    var KITS = predOn ? ['base', 'heat', 'pred'] : ['base', 'heat'];
    var KIT_NAME = { base: 'PVS-14 kit', heat: 'Add HEAT', pred: 'Add PREDATOR' };
    var KIT_FILE = { base: 'pvs14', heat: 'heat', pred: 'predator' };

    /* ------------------------------------------------------------ the state */
    var S = {
      housing: D.start.housing || '',
      fom: D.start.fom || D.grades[0].value,
      kit: hasKits ? (D.start.kit || 'base') : 'base'
    };

    /* NOTHING IS EVER LEFT POINTING AT A DEAD END. A housing swap that lands on
       a grade that housing does not sell, or a grade whose kit is sold out,
       moves to the nearest thing that can actually be bought rather than leaving
       a button that cannot be pressed. */
    function settle() {
      if (!fomExists(S.housing, S.fom) || !fomBuyable(S.housing, S.fom)) {
        for (var i = 0; i < D.grades.length; i++) {
          if (fomBuyable(S.housing, D.grades[i].value)) { S.fom = D.grades[i].value; break; }
        }
      }
      if (hasKits && !kitBuyable(S.housing, S.fom, S.kit)) {
        for (var k = 0; k < KITS.length; k++) {
          if (kitBuyable(S.housing, S.fom, KITS[k])) { S.kit = KITS[k]; break; }
        }
      }
    }

    function gradeIndex() {
      for (var i = 0; i < D.grades.length; i++) if (D.grades[i].value === S.fom) return i;
      return 0;
    }
    function gradeNumber(fomValue) {
      for (var i = 0; i < D.grades.length; i++) if (D.grades[i].value === fomValue) return D.grades[i].n;
      return parseInt(String(fomValue), 10) || 0;
    }
    function oneParcel() { return !hasKits || S.kit === 'base'; }

    /* ------------------------------------------- the live delivery estimate.
       The SAME endpoint and the SAME cache key shape the store's own block uses,
       so the edge cache serves this read and it costs nothing on top. Only three
       things are taken out of the answer: the mode, and the two date labels the
       card itself prints. Not one sentence is written from it. */
    var deCache = {};
    var deToken = 0;
    var deAnswer = null;      /* the answer for the variant the shopper chose */
    var deBase = null;        /* the answer for the PVS on its own, same housing and grade */
    var deSku = null;
    var deBaseSku = null;

    /* ONE ASK, ONE CACHE KEY. Used for the chosen variant and, on a two parcel
       kit, for the PVS on its own, because a kit SKU is deliberately refused a
       window by the server (its thermal half is a different supply chain) and
       the PVS half is not. Same endpoint, same country, same ten minute edge
       cache, so the second ask usually costs nothing at all. */
    function deFetch(sku, mine, apply) {
      var key = sku + '|' + (D.country || '');
      if (Object.prototype.hasOwnProperty.call(deCache, key)) {
        /* A CACHED ANSWER HAS TO MOVE EVERYTHING AN ARRIVING ONE MOVES.
           This branch used to repaint the arrival box only, so going back to a
           grade the page had already asked about left the tag at the top and the
           "where from" line in the cart list describing the PREVIOUS grade.
           Measured in the rig: STANDARD, add PREDATOR, 1400 wore a red Backorder
           tag it had inherited from the 1800 before it. */
        apply(deCache[key], mine);
        return;
      }
      var url = D.deEndpoint + '?sku=' + encodeURIComponent(sku) +
        '&country=' + encodeURIComponent(D.country || '') +
        '&cur=' + encodeURIComponent(D.currency || '');
      var ctl = null;
      try { ctl = new AbortController(); setTimeout(function () { ctl.abort(); }, 4000); } catch (e) { ctl = null; }
      fetch(url, ctl ? { signal: ctl.signal, credentials: 'omit' } : { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          /* The PRO 1800 restock on its way (Bon 2026-09-30), decided in ONE
             place: window.noInbound in snippets/no-delivery-estimate.liquid. */
          if (window.noInbound) j = window.noInbound(j, D.country, D.currency, sku);
          deCache[key] = j;
          apply(j, mine);
        })
        .catch(function () { apply(null, mine); });
    }

    /* BOTH PARCELS GET AN ANSWER, NOT JUST THE ONE THE CART LINE IS NAMED AFTER.
       Bon 2026-09-28: "you need to show the heat and the PVS14 that they ship
       separately and give the estimate for both". The kit variant answers for
       the kit; the plain PVS variant at the same housing and grade answers for
       the goggle parcel. Neither sentence is written here. */
    function askDelivery(sku, baseSku) {
      var mine = ++deToken;
      if (!sku) { deAnswer = null; deBase = null; refreshLive(); return; }
      deFetch(sku, mine, function (j, m) {
        if (m !== deToken) return;
        deAnswer = j;
        refreshLive();
      });
      if (baseSku && baseSku !== sku) {
        deFetch(baseSku, mine, function (j, m) {
          if (m !== deToken) return;
          deBase = j;
          refreshLive();
        });
      } else {
        /* the chosen variant IS the PVS on its own, so there is nothing to ask
           twice and paintArrival reads the one answer for both jobs */
        deBase = null;
      }
    }

    /* THE THREE THINGS THE LIVE ANSWER MOVES, in one place so they can never
       fall out of step with each other: the tag at the top, the arrival extras,
       and the "where from" half of the cart list footer. */
    function refreshLive() {
      paintTags();
      paintArrival();
      paintCart();
    }

    /* HOW MANY DAYS, FROM THE VERY DATE THE CARD SHOWS. Bon asked for
       "[Can Deliver In X Days]" and asked for X to be the same window as the
       dates, so it is counted from those two labels and never from a table of
       its own. A label this cannot read gives no line at all. */
    function daysFromLabel(lab) {
      var s = String(lab == null ? '' : lab);
      var words = s.match(/[A-Za-z]{3,}/g);
      var dm = s.match(/(\d{1,2})(?!\d)/);
      if (!words || !dm) return null;
      var mo = null;
      for (var i = 0; i < words.length; i++) {
        var k = words[i].slice(0, 3).toLowerCase();
        if (Object.prototype.hasOwnProperty.call(MONTHS, k)) { mo = MONTHS[k]; break; }
      }
      if (mo === null) return null;
      var day = parseInt(dm[1], 10);
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var d = new Date(today.getFullYear(), mo, day);
      if ((d - today) < -180 * 86400000) d = new Date(today.getFullYear() + 1, mo, day);
      var diff = Math.round((d - today) / 86400000);
      return diff >= 0 ? diff : null;
    }

    function deMode() { return deAnswer && deAnswer.show === true ? String(deAnswer.mode || '') : ''; }

    /* ------------------------------------------------------------- painting */
    function setText(el, s) {
      if (!el) return;
      var want = String(s == null ? '' : s);
      if (el.textContent !== want) el.textContent = want;
    }
    function setHtml(el, s) {
      if (!el) return;
      var want = String(s == null ? '' : s);
      if (el.innerHTML !== want) el.innerHTML = want;
    }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function tag(cls, text, nodot) {
      return '<span class="no-buy__tag no-buy__tag--' + cls +
        (nodot ? ' no-buy__tag--nodot' : '') + '">' + esc(text) + '</span>';
    }

    function imgFor(url) { return url ? url : (D.fallbackImg || ''); }

    function paint() {
      settle();
      var v = variantFor(S.housing, S.fom, S.kit === 'pred' ? 'base' : S.kit);
      var buyable = !!(v && v.available) && (S.kit !== 'pred' || D.core.available === true);

      /* the hidden input is what the store's own arrival block and the native
         form both read, so it moves first and everything else follows */
      if (v && vidEl && vidEl.value !== String(v.id)) {
        vidEl.value = String(v.id);
      }

      var total = kitPrice(S.housing, S.fom, S.kit);
      var cmp = kitCompare(S.housing, S.fom, S.kit);
      setText(priceEl, total === null ? '' : money(total));
      setText(subEl, total === null ? '' : money(total));
      setText(wasEl, (cmp && total !== null && cmp > total) ? money(cmp) : '');

      /* the chosen values beside each step heading */
      var hv = root.querySelector('[data-no-buy-v="housing"]');
      if (hv) setText(hv, S.housing);
      var kv = root.querySelector('[data-no-buy-v="kit"]');
      if (kv) setText(kv, hasKits ? (KIT_NAME[S.kit] || '') : '');
      var gv = root.querySelector('[data-no-buy-v="grade"]');
      if (gv) setText(gv, S.fom + ' FOM');

      /* the cards */
      var groups = root.querySelectorAll('[data-no-buy-group]');
      for (var gi = 0; gi < groups.length; gi++) {
        var g = groups[gi];
        var name = g.getAttribute('data-no-buy-group');
        var cards = g.querySelectorAll('.no-buy__card');
        for (var ci = 0; ci < cards.length; ci++) {
          var b = cards[ci];
          var val = b.getAttribute('data-no-buy-val');
          b.setAttribute('aria-checked', val === S[name] ? 'true' : 'false');
          if (name === 'kit') {
            var ok = kitBuyable(S.housing, S.fom, val);
            b.disabled = !ok;
            var pr = b.querySelector('[data-no-buy-kprice]');
            var p = kitPrice(S.housing, S.fom, val);
            setText(pr, p === null ? '' : money(p));
            var flag = b.querySelector('[data-no-buy-kflag]');
            if (flag) {
              if (!ok) { flag.hidden = false; flag.className = 'no-buy__flag no-buy__flag--out'; setText(flag, 'Sold out'); }
              else if (val === 'pred') { flag.hidden = false; flag.className = 'no-buy__flag'; setText(flag, 'Free bridge'); }
              else { flag.hidden = true; flag.className = 'no-buy__flag'; setText(flag, ''); }
            }
            var kimg = b.querySelector('img');
            if (kimg) {
              var want = D.kitImg[val + '|' + S.housing] || D.kitImg[val + '|STANDARD'];
              var url = imgFor(want);
              if (url && kimg.getAttribute('data-no-buy-src') !== url) {
                kimg.setAttribute('data-no-buy-src', url);
                kimg.src = url;
              }
              kimg.alt = KIT_NAME[val] + (S.housing ? ', ' + S.housing + ' housing' : '');
            }
          }
        }
      }

      /* the slider, the stops and the meter */
      var idx = gradeIndex();
      var last = D.grades.length - 1;
      var f = last > 0 ? idx / last : 0;
      if (knob) knob.style.left = 'calc(26px + (100% - 52px) * ' + f + ')';
      if (fill) fill.style.width = 'calc((100% - 52px) * ' + f + ')';
      if (range) range.value = String(idx);

      var dots = root.querySelectorAll('[data-no-buy-dot]');
      for (var di = 0; di < dots.length; di++) {
        var dp = last > 0 ? di / last : 0;
        var dok = fomBuyable(S.housing, D.grades[di].value);
        dots[di].style.left = 'calc(26px + (100% - 52px) * ' + dp + ')';
        dots[di].classList.toggle('is-on', dok && di <= idx);
        dots[di].classList.toggle('is-dead', !dok);
      }
      var stops = root.querySelectorAll('[data-no-buy-stop]');
      for (var si = 0; si < stops.length; si++) {
        var val2 = D.grades[si].value;
        var exists = fomExists(S.housing, val2);
        var sok = fomBuyable(S.housing, val2);
        stops[si].classList.toggle('is-on', si === idx);
        stops[si].disabled = !sok;
        var note = stops[si].querySelector('[data-no-buy-note]');
        if (note) {
          var step = '';
          if (sok && si !== idx && total !== null) {
            var gp = kitPrice(S.housing, val2, S.kit);
            if (gp !== null) step = moneyStep(gp - total);
          }
          setText(note, sok ? step : (exists ? 'Sold out' : 'Pro only'));
          note.classList.toggle('is-step', sok && step !== '');
        }
      }
      if (barsEl) {
        var lit = Math.round(14 + f * 6);
        var kids = barsEl.children;
        for (var bi = 0; bi < kids.length; bi++) kids[bi].classList.toggle('is-lit', bi < lit);
      }

      /* the sample picture. A grade whose picture has not been uploaded shows
         no sample rather than a broken one. */
      if (sampleEl) {
        var simg = D.fomImg[String(gradeNumber(S.fom))];
        if (simg) {
          if (sampleEl.getAttribute('data-no-buy-src') !== simg) {
            sampleEl.setAttribute('data-no-buy-src', simg);
            sampleEl.src = simg;
          }
          if (sampleWrap) sampleWrap.hidden = false;
        } else if (sampleWrap) {
          sampleWrap.hidden = true;
        }
      }

      setHtml(gfootEl, buyable ? '' : tag('red', 'Sold out'));

      /* the button */
      if (addBtn) {
        addBtn.disabled = !buyable;
        setText(addLabel, buyable ? 'Add to cart' : 'Sold out');
        setText(addPrice, buyable && total !== null ? money(total) : '');
      }
      if (errEl) { errEl.hidden = true; setText(errEl, ''); }

      /* A GRADE THIS PAGE HAS NOT YET HEARD AN ANSWER FOR CLAIMS NOTHING.
         The old answer is dropped the instant the variant moves, so no tag and
         no "where from" line can describe the grade the shopper just left. This
         is the same rule the store's own arrival block follows. */
      var sku = v ? v.sku : '';
      var bv = variantFor(S.housing, S.fom, 'base');
      var baseSku = bv ? bv.sku : '';
      if (sku !== deSku) { deSku = sku; deAnswer = null; }
      if (baseSku !== deBaseSku) { deBaseSku = baseSku; deBase = null; }
      refreshLive();
      askDelivery(sku, baseSku);

      /* tell the store's own arrival block that the variant moved. It listens on
         the document for exactly this, and its United States only lock runs in
         the same breath. */
      try { document.dispatchEvent(new CustomEvent('variant:change', { detail: { id: v ? v.id : 0 } })); } catch (e) { /* older browser, the block also polls */ }
    }

    /* WHAT THE SHOPPER IS TOLD ABOUT ARRIVAL, and the split is deliberate:
       the CARD is the store's, and only these three things are ours, because
       they are about the shape of the order rather than about a date:
         1. that it comes in two parcels
         2. Bon's [Can Deliver In X Days], from the card's own two dates
         3. which parcel comes from the factory, with no day count on the
            PREDATOR half, because no dated line for it is approved. */
    function paintArrival() {
      var two = hasKits && S.kit !== 'base';
      if (estHead) estHead.hidden = !two;

      var mode = deMode();
      var mn = null, mx = null;
      if (mode === 'eta') {
        mn = daysFromLabel(deAnswer.min_label);
        mx = daysFromLabel(deAnswer.max_label);
      }
      if (daysEl) {
        if (!two && mn !== null && mx !== null) {
          var txt = mn === mx
            ? '[Can Deliver In ' + mn + ' Days]'
            : '[Can Deliver In ' + mn + ' to ' + mx + ' Days]';
          setText(daysEl, txt);
          daysEl.hidden = false;
        } else {
          daysEl.hidden = true;
          setText(daysEl, '');
        }
      }

      var rows = [];

      /* THE GOGGLE PARCEL FIRST, BECAUSE IT IS THE THING BEING BOUGHT.
         Bon 2026-09-28, on a non US HEAT kit page: "Right now, I only see the
         delivery estimate when I click the heat. It says the heat ships in about
         1 week. And that could be misleading because you need to show the heat
         and the PVS14 that they ship separately and give the estimate for both."
         Until tonight a two parcel kit printed the thermal half's line and
         NOTHING for the goggle, because the kit SKU is refused a window by the
         server and the card above therefore stayed empty. */
      if (two) {
        var pr = pvsParcelRow();
        if (pr) rows.push(pr);
      }

      if (two && S.kit === 'heat') {
        rows.push(row('grey', 'From the factory',
          'Because of high holiday demand, the HEAT and its bridge currently take roughly <b>14 to 30 days</b> to ship out from our factory, then 15 to 25 days in transit',
          'Built and sent by our factory, not from our warehouse.'));
      }
      if (two && S.kit === 'pred') {
        /* NO DAY COUNT AND NO DATE ON THE PREDATOR HALF. The old day figures
           were retired from every surface on 2026-09-19 and no dated line has
           been approved since, so what is said is the queue and nothing else. */
        /* Bon 2026-09-28: the first wave ships 15 October to late October; an order
           placed now is estimated about 45 days out, counted from the day it is seen. */
        var predEta = new Date(Date.now() + 45 * 864e5);
        var predLbl = predEta.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        rows.push(row('grey', 'Built to order',
          'The PREDATOR and its dual dovetail bridge <b>ship in order of payment</b>. The first wave ships 15 October to late October. Ordered today: estimated to ship around <b>' + predLbl + '</b>, about 45 days from your order',
          'An estimate, not a promise. Sent by our factory, not from our warehouse.'));
      }
      setHtml(rowsEl, rows.join(''));
    }

    /* WHICH ANSWER DESCRIBES THE GOGGLE PARCEL. The plain PVS variant at the
       same housing and grade, which is the same physical unit the kit carries
       and follows the same route (rulebook-orders-and-fulfilment HV1: on a
       bridge kit the PVS body is ours to ship and the thermal half is the
       factory's). When the shopper is already on the plain PVS, that is the one
       answer we have and it serves both jobs. */
    function baseAnswer() {
      if (deBase && deBase.show === true) return deBase;
      if (deBaseSku && deBaseSku === deSku && deAnswer && deAnswer.show === true) return deAnswer;
      return null;
    }

    /* ONE ROW FOR THE GOGGLE PARCEL, IN EVERY COUNTRY, AND NEVER A SENTENCE OF
       THIS FILE'S OWN. Every word is the server's: the dates on the shelf
       answer, the window on the factory answer, the backorder on the backorder
       answer. An answer we do not have prints no row at all, which is the same
       rule the card itself follows. */
    function pvsParcelRow() {
      var a = baseAnswer();
      if (!a) return null;
      var name = esc(D.shortName || 'the unit');
      var m = String(a.mode || '');
      /* THE SMALL PRINT GOES ON THE ROW ONLY WHEN THE CARD IS NOT ALREADY
         SAYING IT. On an 1800 kit the card above carries the same backorder
         answer word for word, so repeating its note here is noise; on a 1400
         HEAT kit the card is silent (the kit SKU is refused a window) and the
         note is the only place the shopper reads it. */
      var cardSpeaking = !!(deAnswer && deAnswer.show === true);
      var small = cardSpeaking ? '' : esc(a.note_text || '');

      if (m === 'eta') {
        var mn2 = daysFromLabel(a.min_label);
        var mx2 = daysFromLabel(a.max_label);
        var when = (mn2 !== null && mx2 !== null)
          ? (mn2 === mx2
              ? 'in about <b>' + mn2 + ' days</b>'
              : 'in about <b>' + mn2 + ' to ' + mx2 + ' days</b>')
          : '<b>' + esc(a.min_label || '') + '</b> to <b>' + esc(a.max_label || '') + '</b>';
        return row('green', 'From our US warehouse',
          'The ' + name + ' arrives ' + when,
          'It leaves on its own as soon as it is packed and does not wait for the other parcel.');
      }

      if (m === 'backorder') {
        return row('grey', 'Backorder',
          'The ' + name + ': ' + esc(a.lead_text_short || a.lead_text || ''), small);
      }

      if (m === 'inbound') {
        return row('grey', 'On its way',
          'The ' + name + ': ' + esc(a.eta_text || a.lead_text || ''), small);
      }

      if (m === 'intl') {
        /* `eta_text` is the measured window on its own, added to the server on
           2026-09-28. A function that has not been redeployed yet sends only
           `lead_text`, which is still a true sentence, so the row simply reads
           the older wording until the deploy lands. */
        return row('grey', 'Built to order',
          'The ' + name + ': ' + esc(a.eta_text || a.lead_text || ''), small);
      }

      if (m === 'restock') {
        return row('grey', 'Built to order',
          'The ' + name + ': ' + esc(a.lead_text || ''), small);
      }

      /* us_only, out_of_stock and anything this file does not know: the card
         above already says it and it is not a shipping window, so no row. */
      return null;
    }

    function row(cls, tagText, lead, sub) {
      return '<div class="no-buy__row">' +
        '<span class="no-buy__rtag">' + tag(cls, tagText) + '</span>' +
        '<span class="no-buy__rtxt">' + lead +
        '<span class="no-buy__rsub">' + sub + '</span></span></div>';
    }

    /* WHAT REALLY GOES IN THE CART, listed under the button before it is
       pressed, and built from the same function that builds the POST, so the
       list and the cart can never disagree.
       THE G24 AND THE J-ARM ARE NEVER LINES OF THEIR OWN. They are inside the
       monocular, so they are a sentence under its line (Bon 2026-09-27). */
    /* ADD-ONS, 53A (2026-10-19). The switch row under this buy box (the theme's
       product-info-upsell blocks: the vented helmet, the NGAL, any other switch)
       used to be ignored here, so a switched on add-on never reached the cart and
       nobody was told. Every switched on add-on now rides in the SAME cart call as
       the main item, quantity 1, as the exact variant its menus pick. A pick that
       is sold out is never added: the button refuses and says which one. */
    var ADDON_MSG = 'is sold out in that pick. Choose another size or colour, or switch it off.';
    function addonScope() {
      return (root.closest && root.closest('product-info')) || document;
    }
    function addonState() {
      var res = { lines: [], blocked: [] };
      var ups = addonScope().querySelectorAll('product-info-upsell');
      for (var i = 0; i < ups.length; i++) {
        var u = ups[i];
        if (u.getAttribute('data-selected') !== 'true') continue;
        var tEl = u.querySelector('.upsell__title');
        var title = tEl ? String(tEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (!title) title = u.getAttribute('data-handle') || 'Add-on';
        var vs = null;
        var js = u.querySelector('script[type="application/json"]');
        if (js) { try { vs = JSON.parse(js.textContent); } catch (e) { vs = null; } }
        var v = null;
        if (vs && vs.length) {
          var sels = u.querySelectorAll('select.variant-dropdown');
          var want = [];
          for (var s2 = 0; s2 < sels.length; s2++) want.push(String(sels[s2].value));
          for (var j = 0; j < vs.length && !v; j++) {
            var o = vs[j].options || [vs[j].option1, vs[j].option2, vs[j].option3];
            var same = true;
            for (var q = 0; q < want.length; q++) { if (String(o[q]) !== want[q]) { same = false; break; } }
            if (same) v = vs[j];
          }
          if (!v && !sels.length && vs.length === 1) v = vs[0];
        }
        if (!v || !v.available || !v.id) { res.blocked.push(title); continue; }
        res.lines.push({ id: v.id, qty: 1, name: title + (v.public_title ? ', ' + v.public_title : ''),
          sku: v.sku || '', price: v.price, addon: true });
      }
      /* LENS-CAPS-UPSELL-1019 (2026-10-19). Add-on steps INSIDE this column
         (the lens cover step, snippets/no-lens-upsell.liquid) mark their picked
         card with data-no-addon and data-selected="true" and carry the exact
         variant on the card itself: data-id, data-qty (2 on the PVS-31, one per
         tube), data-unit (the live price in cents), data-name, data-label (a
         plain words line shown where a SKU would be; no SKU is ever printed)
         and data-available. They ride in the same cart call as the helmet. */
      var own = root.querySelectorAll('[data-no-addon][data-selected="true"]');
      for (var oi = 0; oi < own.length; oi++) {
        var oe = own[oi];
        if (oe.hidden) continue;
        var oname = String(oe.getAttribute('data-name') || 'Add-on');
        var oid = Number(oe.getAttribute('data-id'));
        var oqty = Math.max(1, parseInt(oe.getAttribute('data-qty'), 10) || 1);
        var ounit = Number(oe.getAttribute('data-unit'));
        if (!oid || oe.getAttribute('data-available') === 'false' || !isFinite(ounit)) { res.blocked.push(oname); continue; }
        res.lines.push({ id: oid, qty: oqty, name: oname, sku: String(oe.getAttribute('data-label') || ''),
          price: ounit * oqty, addon: true });
      }
      return res;
    }
    function addonSum(lines) {
      var t = 0;
      for (var i = 0; i < lines.length; i++) if (lines[i].addon && typeof lines[i].price === 'number') t += lines[i].price;
      return t;
    }
    (function watchAddons() {
      var sc = addonScope();
      var later = function (e) {
        var t = e && e.target;
        if (!t || !t.closest || !t.closest('product-info-upsell')) return;
        setTimeout(function () { try { paintCart(); } catch (err) { /* the list simply stays */ } }, 60);
      };
      sc.addEventListener('click', later);
      sc.addEventListener('change', later);
      /* LENS-CAPS-UPSELL-1019: a step inside this column says "my pick moved"
         and the list and the button follow at once; the ADV-COTI step reads the
         add-on sum from here so its button total counts them too */
      root.addEventListener('no-buy:addons', function () { try { paintCart(); } catch (err) { /* the list simply stays */ } });
      root.__noAddonSum = function () { try { return addonSum(addonState().lines); } catch (err) { return 0; } };
    }());

    function cartLines() {
      var v = variantFor(S.housing, S.fom, S.kit === 'pred' ? 'base' : S.kit);
      if (!v || !v.available) return null;
      var grade = S.fom + ' FOM';
      var house = S.housing ? S.housing + ' ' : '';
      var out = [];
      var ships = '';
      var from = fromWords();

      var unit = (D.shortName || 'The unit') + ' ' + house + grade;
      var name = D.shortName || 'unit';
      var fromBit = from ? ' The ' + name + ' ' + from + '.' : '';

      if (!hasKits || S.kit === 'base') {
        out.push({ id: v.id, qty: 1, name: unit, sku: v.sku, price: v.price, note: D.comesWith });
        ships = 'One parcel.' + (from ? ' It ' + from + '.' : '');
      } else if (S.kit === 'heat') {
        /* ONE variant, not three. The monocular, the HEAT and the bridge all sit
           inside the PVS-14 + HEAT + BRIDGE KIT variant, which is why the live
           page adds a single line. Two suppliers still ship it. */
        var hv = variantFor(S.housing, S.fom, 'heat');
        out.push({ id: hv.id, qty: 1, name: unit + ' plus HEAT and bridge kit', sku: hv.sku, price: hv.price, note: D.comesWith });
        ships = 'One cart line, two parcels.' + fromBit +
          ' The HEAT and its bridge come from the factory.';
      } else {
        /* THE LIVE ORDER, copied: CORE, then the bridge, then the PVS-14.
           predator-kit.js builds [core, bridge] and pvs14-upsell.js pushes the
           monocular on the end of that same array. */
        out.push({ id: D.core.id, qty: 1, name: D.core.name, sku: D.core.sku, price: D.core.price });
        out.push({ id: D.bridge.id, qty: 1, name: D.bridge.name + ', a ' + money(D.bridge.price) + ' value', sku: D.bridge.sku, price: D.bridge.price, free: true });
        out.push({ id: v.id, qty: 1, name: unit, sku: v.sku, price: v.price, note: D.comesWith });
        ships = 'Two parcels.' + fromBit +
          ' The PREDATOR and its bridge come from the factory.';
      }
      var ad = addonState();
      for (var a = 0; a < ad.lines.length; a++) out.push(ad.lines[a]);
      if (ad.lines.length) {
        /* LENS-CAPS-UPSELL-1019: "One parcel" no longer reads true once an add-on rides along */
        if (/^One parcel\./.test(ships)) ships = ships.replace(/^One parcel\./, 'The ' + (D.shortName || 'goggle') + ' in one parcel.');
        ships += ' Add-ons ship on their own.';
      }
      out.blocked = ad.blocked;
      out.ships = ships;
      return out;
    }

    /* WHERE THE MONOCULAR COMES FROM, and it is the server's answer that
       decides, never a table here. A grade the store is holding is posted from
       the warehouse; anything else is built first, and saying "from our US
       warehouse" over a backorder would be the small lie the arrival card was
       rewritten to stop telling. */
    function fromWords() {
      /* THE GOGGLE'S OWN ANSWER, NOT THE KIT'S. On a two parcel kit the kit SKU
         is refused a window by the server, so this used to read empty and the
         cart list said where the HEAT came from and nothing at all about the
         PVS. Same fault Bon caught in the arrival box, one line lower down. */
      var a = baseAnswer();
      var mode = a ? String(a.mode || '') : '';
      if (mode === 'eta') return 'is posted from our US warehouse';
      if (mode === 'inbound') return 'is posted from our US warehouse when the restock lands';
      if (mode === 'backorder' || mode === 'restock' || mode === 'intl') return 'is built for you first, then posted';
      return '';
    }

    function paintCart() {
      if (!cartEl) return;
      var lines = cartLines();
      if (!lines) { cartEl.hidden = true; setHtml(cartEl, ''); return; }
      var html = '<p class="no-buy__carth">What goes in the cart, ' + lines.length +
        (lines.length === 1 ? ' line' : ' lines') + '</p><ul>';
      for (var i = 0; i < lines.length; i++) {
        var l = lines[i];
        html += '<li><span class="no-buy__nm">' + esc(l.name) +
          '<span class="no-buy__sku">' + esc(l.sku) + ' &middot; qty ' + l.qty + '</span>' +
          (l.note ? '<span class="no-buy__sku no-buy__comes">' + esc(l.note) + '</span>' : '') +
          '</span><span class="no-buy__amt' + (l.free ? ' is-free' : '') + '">' +
          (l.free ? 'Free' : esc(money(l.price))) + '</span></li>';
      }
      html += '</ul>';
      if (lines.ships) html += '<p class="no-buy__cartf">' + esc(lines.ships) + '</p>';
      cartEl.hidden = false;
      setHtml(cartEl, html);
      /* 53A: the button price counts the switched on add-ons, and a sold out pick says so at once */
      var base = kitPrice(S.housing, S.fom, S.kit);
      if (addBtn && !addBtn.disabled && base !== null) setText(addPrice, money(base + addonSum(lines)));
      if (lines.blocked && lines.blocked.length) showErr(lines.blocked.join(', ') + ' ' + ADDON_MSG);
      else if (errEl && String(errEl.textContent || '').indexOf(ADDON_MSG) >= 0) { errEl.hidden = true; setText(errEl, ''); }
      /* LENS-CAPS-UPSELL-1019: tell the steps that paint over this button (the ADV-COTI step) that it was just painted */
      try { root.dispatchEvent(new CustomEvent('no-buy:cart', { bubbles: true })); } catch (err5) { /* older browser */ }
    }

    function paintTags() {
      if (!tagsEl) return;
      var v = variantFor(S.housing, S.fom, S.kit === 'pred' ? 'base' : S.kit);
      var buyable = !!(v && v.available) && (S.kit !== 'pred' || D.core.available === true);
      var mode = deMode();
      var out = [];
      if (!buyable) out.push(tag('red', 'Sold out'));
      else if (mode === 'us_only') out.push(tag('red', (deAnswer && deAnswer.chip_label) ? String(deAnswer.chip_label) : 'United States only'));
      else if (mode === 'backorder') out.push(tag('red', 'Backorder'));
      else if (mode === 'eta' && oneParcel()) out.push(tag('green', 'In stock'));
      if (hasKits && S.kit === 'pred') {
        out.push(tag('black', 'Bridge free, a ' + money(D.bridge.price) + ' value', true));
      }
      setHtml(tagsEl, out.join(''));
    }

    /* ------------------------------------------------------------- the wiring */
    function pick(name, val) {
      if (S[name] === val) return;
      S[name] = val;
      paint();
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('.no-buy__card') : null;
      if (card && root.contains(card)) {
        if (card.disabled) return;
        var grp = card.closest('[data-no-buy-group]');
        if (grp) pick(grp.getAttribute('data-no-buy-group'), card.getAttribute('data-no-buy-val'));
        return;
      }
      var stop = e.target.closest ? e.target.closest('[data-no-buy-stop],[data-no-buy-dot]') : null;
      if (stop) {
        touched();
        var i = parseInt(stop.getAttribute('data-no-buy-stop') || stop.getAttribute('data-no-buy-dot'), 10);
        if (!(i >= 0) || !D.grades[i]) return;
        if (!fomBuyable(S.housing, D.grades[i].value)) return;
        pick('fom', D.grades[i].value);
        return;
      }
      if (e.target.closest && e.target.closest('[data-no-buy-zoomopen]')) openZoom();
    });

    /* the handle nudges itself a few times so nobody misses that it is a slider,
       and it goes quiet for good the moment the thing is touched */
    function touched() {
      if (!slider || !slider.classList.contains('is-hint')) return;
      slider.classList.remove('is-hint');
      if (hintEl) hintEl.hidden = true;
    }
    if (slider) {
      ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
        slider.addEventListener(ev, touched, { passive: true });
      });
    }
    if (range) {
      range.addEventListener('input', function () {
        touched();
        var i = parseInt(range.value, 10);
        if (!D.grades[i] || !fomBuyable(S.housing, D.grades[i].value)) {
          range.value = String(gradeIndex());
          return;
        }
        pick('fom', D.grades[i].value);
      });
    }

    /* A PICTURE THAT IS NOT UPLOADED YET FALLS BACK TO THE PRODUCT'S OWN,
       so the column is never broken while main is still uploading. */
    root.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      if (!img.hasAttribute('data-no-buy-imgfb')) {
        if (img === sampleEl && sampleWrap) { sampleWrap.hidden = true; }
        return;
      }
      if (img.getAttribute('data-no-buy-fellback') === '1') return;
      img.setAttribute('data-no-buy-fellback', '1');
      if (D.fallbackImg) img.src = D.fallbackImg;
    }, true);

    /* ------------------------------------------------------------ the zoom */
    function openZoom() {
      if (!zoom) return;
      paintZoom();
      zoom.hidden = false;
      zoom.classList.add('is-open');
      var x = zoom.querySelector('[data-no-buy-zclose]');
      if (x) x.focus();
    }
    function closeZoom() {
      if (!zoom) return;
      zoom.classList.remove('is-open');
      zoom.hidden = true;
    }
    function paintZoom() {
      var t = zoom.querySelector('[data-no-buy-ztitle]');
      var big = zoom.querySelector('[data-no-buy-zimg]');
      var th = zoom.querySelector('[data-no-buy-zthumbs]');
      setText(t, S.fom + ' FOM');
      var u = (D.fomImgBig || D.fomImg)[String(gradeNumber(S.fom))] || D.fallbackImg || '';
      if (big && big.src !== u) big.src = u;
      var html = '';
      for (var i = 0; i < D.grades.length; i++) {
        var g = D.grades[i];
        var dead = !fomBuyable(S.housing, g.value);
        var url = D.fomImg[String(g.n)] || D.fallbackImg || '';
        html += '<button type="button" data-no-buy-zg="' + esc(g.value) + '" class="' +
          (g.value === S.fom ? 'is-on' : '') + '"' + (dead ? ' disabled' : '') + '>' +
          '<img src="' + esc(url) + '" alt="" loading="lazy" decoding="async" data-no-buy-imgfb>' +
          '<span>' + g.n + '</span></button>';
      }
      setHtml(th, html);
    }
    if (zoom) {
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom) { closeZoom(); return; }
        if (e.target.closest && e.target.closest('[data-no-buy-zclose]')) { closeZoom(); return; }
        var b = e.target.closest ? e.target.closest('[data-no-buy-zg]') : null;
        if (b && !b.disabled) {
          pick('fom', b.getAttribute('data-no-buy-zg'));
          paintZoom();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && zoom.classList.contains('is-open')) closeZoom();
      });
    }

    /* --------------------------------------------------------------- the cart */
    var busy = false;

    /* 77A (2026-10-19). THE CART DRAWER'S PRESELECTED UPSELLS (shipping insurance).
       The theme's own product form puts every cart-drawer-upsell that reads
       data-selected="true" into the same add call as the main item. A buy that
       skips the theme form skipped them too, so the insurance line was lost.
       They are added here the same way: only the ones still switched on, and
       never one the cart already holds, so the line is added once, never twice. */
    function drawerExtras(already) {
      var ids = [];
      var seen = {};
      (already || []).forEach(function (x) { seen[String(x)] = 1; });
      Array.prototype.forEach.call(document.querySelectorAll('cart-drawer-upsell[data-selected="true"]'), function (u) {
        var id = Number(u.getAttribute('data-id'));
        if (id && !seen[String(id)]) { seen[String(id)] = 1; ids.push(id); }
      });
      if (!ids.length) return Promise.resolve([]);
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var have = {};
          ((c && c.items) || []).forEach(function (it) { have[String(it.variant_id)] = 1; });
          return ids.filter(function (id) { return !have[String(id)]; });
        })
        .catch(function () { return []; });
    }

    function cartHost() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }
    function sectionIds(host) {
      try {
        if (host && typeof host.getSectionsToRender === 'function') {
          return host.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
        }
      } catch (e) { /* the drawer simply will not be repainted */ }
      return [];
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var lines = cartLines();
        if (!lines || !lines.length) return;
        if (lines.blocked && lines.blocked.length) { showErr(lines.blocked.join(', ') + ' ' + ADDON_MSG); return; }
        for (var i = 0; i < lines.length; i++) {
          if (!lines[i].id) { showErr('This kit cannot be added right now.'); return; }
        }
        busy = true;
        if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.disabled = true; }

        var payload = { items: [] };
        for (var k = 0; k < lines.length; k++) payload.items.push({ id: lines[k].id, quantity: lines[k].qty });
        var host = cartHost();
        var ids = sectionIds(host);
        if (ids.length) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }

        drawerExtras(payload.items.map(function (x) { return x.id; })).then(function (extra) {
          if (extra.length) payload.items = extra.map(function (id) { return { id: id, quantity: 1 }; }).concat(payload.items);
          return fetch(D.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
          });
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed');
            var opened = false;
            try {
              if (host && typeof host.renderContents === 'function' && res.body && res.body.sections) {
                if (host.classList && host.classList.contains('is-empty')) host.classList.remove('is-empty');
                host.renderContents(res.body);
                opened = true;
              }
            } catch (err2) { opened = false; }
            if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (err3) { /* the drawer is already handled */ } }
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (err4) { /* older browser */ }
            release();
            if (!opened) window.location.href = D.cartUrl;
          })
          .catch(function (err) {
            release();
            showErr(err && err.message ? err.message : 'Add to cart failed');
          });
      });
    }

    function release() {
      busy = false;
      if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = false; }
    }
    function showErr(msg) {
      if (!errEl) return;
      setText(errEl, msg);
      errEl.hidden = false;
    }

    /* Liquid already printed the opening state, so the first paint only has to
       agree with it. Nothing is built here, which is why the page does not shift
       when this file runs. */
    paint();
  }

  function start() {
    var all = document.querySelectorAll('[data-no-buy]');
    for (var i = 0; i < all.length; i++) boot(all[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
